export class ProviderCalendar{
    constructor(){}

    ProviderCalendarID: number;
    WeekDay: number; //enum
    StartDayMinute: number;
    EndDayMinute: number;
    IsInDiscount: boolean;
    IsEnable: boolean;
}